import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './../../../_services/auth.service'; 
import { environment } from 'environments/environment';

@Component({
  selector: 'vehicleDeployment',
  templateUrl: './veh-deployment.component.html',  
})

export class VehDeploymentComponent {
    public prjId:any
    public userId:any
    public empUploadImgModel:any
    constructor(private http : HttpClient,private auth : AuthService){}  

    // detectFiles(event) {
    //     let fileList: FileList = event.target.files;
    //     if(fileList.length > 0) {
    //         let file: File = fileList[0];
    //         let formData:FormData = new FormData();
    //         formData.append('uploadFile', file, file.name);
    //         let headers = new Headers();
    //         /** In Angular 5, including the header Content-Type can invalidate your request */
    //         headers.append('Content-Type', 'multipart/form-data');
    //         headers.append('Accept', 'application/json');
    //         let options = new RequestOptions({ headers: headers });
    //         this.http.post(`${this.apiEndPoint}`, formData, options)
    //             .map(res => res.json())
    //             .catch(error => Observable.throw(error))
    //             .subscribe(
    //                 data => console.log('success'),
    //                 error => console.log(error)
    //             )
    //     }
    // }

     detectFiles(event) {

        let fileList: FileList = event.target.files;
        if(fileList.length > 0) {
            let file: File = fileList[0];
            let formData:FormData = new FormData();
            console.log(file.name);
            
            formData.append('uploadFile', file, file.name);
            const req = new Request( environment.apiUrl +
                'excelUpload/uploadFile',
                {
                    method: 'post',
                    body:formData,
                    headers: {
                        
                    }
                });
            fetch(req).then(response => console.log(response));
            ;
        }

        
    }
  
  ngOnInit(){}

}
 


// WEBPACK FOOTER //
// ./src/app/admin/vehicles/deploymentUploader/veh-deployment.component.ts